import {BaseModel} from './baseModel';


export class EntityId extends BaseModel {

  id: number;

}
